import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, Flex, SimpleGrid, Text, Title } from "@mantine/core";
import { DescriptionOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useGetFilesQuery } from "../../graphql/graphql";
import { LoadingCards } from "../Loading/LoadingCards";
import { FileItem } from "../Misc/FileItem";
export const FileAccordion = ({ caregiverId, patientId, handlers }) => {
    // Queries
    const [{ data, fetching }] = useGetFilesQuery({
        variables: {
            caregiverId,
            patientId
        }
    });
    // Data
    const files = useMemo(() => (data?.files?.files ?? []).filter((file) => file !== null), [data]);
    // Auto-expand the accordion once when files are fetched
    const [accordionValue, setAccordionValue] = useState(null);
    useEffect(() => {
        if (files.length > 0) {
            setAccordionValue("Files");
        }
    }, [files.length]);
    return (_jsx(Accordion, { variant: "outline", value: accordionValue, onChange: setAccordionValue, children: _jsxs(Accordion.Item, { value: "Files", children: [_jsx(Accordion.Control, { children: _jsxs(Flex, { gap: "xs", align: "center", children: [_jsx(SvgIcon, { component: DescriptionOutlined, style: {
                                    width: "1rem",
                                    color: "var(--mantine-color-gray-6)"
                                } }), _jsx(Title, { order: 5, children: "Files" })] }) }), _jsxs(Accordion.Panel, { children: [fetching && _jsx(LoadingCards, { numCards: 5, height: 1.5 }), !fetching && files.length > 0 && (_jsx(SimpleGrid, { cols: 3, spacing: "sm", verticalSpacing: "sm", children: files.map((file) => (_jsx(FileItem, { file: file, handlers: handlers }, file.fileId))) })), !fetching && files.length === 0 && (_jsx(Text, { variant: "label-muted", children: "No files found" }))] })] }) }));
};
